<div class="search">
  <input class="form-control" type="text" name="search" [(ngModel)]="searchText" (input)="searchThis()" autocomplete="off" [placeholder]="placeholder">
</div>